const Actions = {
  Navigate: {
    DO: 'app.actions.navigate.do'
  }
};

const Mutations = {
  ActiveView: {
    SET: 'app.mutations.active-view.set'
  }
};

const Views = {
  Employees: 'app-navigation.views.employees',
  ReportsOfSickness: 'app-navigation.views.reports-of-sickness',
  WorkStock: 'app-navigation.views.work-stock'
};

export default {
  Actions,
  Mutations,
  Views
};
